// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wcc-heatmap__hint{display:flex;padding:3px 5px;background-color:#5ca2dd;color:#fff;border-radius:4px}.wcc-heatmap__hint__content{flex-grow:1}.wcc-heatmap__hint__controls{flex-shrink:0}.wcc-heatmap__hint__control{display:flex;justify-content:center;align-items:center;width:20px;height:20px;transition:color ease-in-out 250ms;color:#fff;cursor:pointer}.wcc-heatmap__hint__control:hover{color:#f8f8f7}", ""]);
// Exports
module.exports = exports;
